export const isIframe = () => window.location !== window.parent.location;
